module.exports = __webpack_public_path__ + "static/media/ygraph.18861b37.svg";